module.exports = __webpack_public_path__ + "img/developing-businesses.9be9b6a1.svg";